import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import {
    ANONYM_USER,
    IS_B2B_BIZ_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_ONPREMISE,
    IS_PHONE_BROWSER,
} from 'reactApp/appHelpers/configHelpers';

const DISABLE_FEATURE = IS_B2B_BIZ_USER || IS_PHONE_BROWSER || IS_DOCUMENTS_DOMAIN || IS_ONPREMISE || IS_MY_TEAM || ANONYM_USER;

/* CLOUDWEB-20332 Фейкдор. Суммаризация текстовых файлов  */
export const fakedoorSummarization: boolean = !DISABLE_FEATURE && isFeature('fake-summaization');
export const fakedoorSummarizationClickCount: number = getFeature('fake-summaization-show-limit') || 2;
export const fakedoorSummarizationExts: string[] = getFeature('fake-summaization-file-types') || ['pdf', 'docx', 'doc'];
